const Perfil = {
  Administrador: "Administrador",
  Coordenador: "Coordenador",
  Funcionário: "Funcionário",
  Gerente: "Gerente"
}



export default Perfil;
